// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__14618","detailsBorder":"styles_detailsBorder__1ZUgk"};